module.exports = __webpack_public_path__ + "static/media/20.809c31b1.jpeg";